// extracted by mini-css-extract-plugin
module.exports = {"list":"ChooseServices_list__2K-an","selected":"ChooseServices_selected__RgdfG","checkbox":"ChooseServices_checkbox__13ReK","checkmark":"ChooseServices_checkmark__1lHZh"};